import { getPricingTest, getSemPricingTest } from '@src/state/site/selectors'
import { SiteState } from '@src/state/site/types'
import { pricingJsonParse } from '../pricingJsonParse'
import { useOptimizelyFeature } from './useOptimizelyFeature'

interface UsePriceTestArgs {
  site: SiteState
  planPrice?: string
  priceExperiment?: string
  hasFreeTrial?: boolean
  basePrice?: number
}

const usePriceTest = ({
  site,
  planPrice = '$9.95',
  priceExperiment = 'BASE',
  hasFreeTrial = true,
  basePrice = 9.95,
}: UsePriceTestArgs) => {
  // Only one feature test will be enabled at a time (either user will come from SEM or non SEM)
  const {
    variables: pricingVariables,
    clientReady: pricingClientReady,
    isEnabled: pricingTestEnabled,
  } = useOptimizelyFeature(getPricingTest(site))
  const {
    variables: semPricingVariables,
    clientReady: semPricingClientReady,
    isEnabled: semPricingTestEnabled,
  } = useOptimizelyFeature(getSemPricingTest(site))
  const pricingExperimentReady = pricingClientReady && semPricingClientReady
  let freeTrial = hasFreeTrial
  let price = planPrice
  let experiment = priceExperiment
  let updatedBasePrice = basePrice
  if (pricingExperimentReady && (pricingTestEnabled || semPricingTestEnabled)) {
    try {
      let pricingJson = '{}'
      if (pricingTestEnabled) {
        pricingJson = pricingVariables.pricingJson as string
      } else if (semPricingTestEnabled) {
        pricingJson = semPricingVariables.pricingJson as string
      }
      const data = pricingJsonParse(pricingJson)
      freeTrial = data.freeTrial
      price = data.price
      experiment = data.pricingExperiment
      updatedBasePrice = data.basePrice
    } catch (error) {
      return {
        freeTrial,
        price,
        experiment,
        pricingExperimentReady,
        basePrice: updatedBasePrice,
      }
    }
  }
  return {
    freeTrial,
    price,
    experiment,
    pricingExperimentReady,
    basePrice: updatedBasePrice,
  }
}

export default usePriceTest



// WEBPACK FOOTER //
// ./src/utils/hooks/usePriceTest.ts